import { LLM_MODEL_PRICING } from './llm-pricing';

/**
 * The LLM models the platform supports, in one place (PD-16759).
 *
 * The provider cost table (`LLM_MODEL_COSTS`) must cover this list: a
 * supported model with no cost entry records a NULL cost, so
 * `llm-pricing.test.ts` checks every id here.
 *
 * `AGENT_LLM_MODELS` is the list crm-api's `LLMFactoryService.getProviderInfo`
 * declares for the conversation agents; it moved here unchanged so the
 * cost coverage test sees the same list the factory serves.
 */
export const AGENT_LLM_MODELS: Readonly<{
	claude: ReadonlyArray<string>;
	openai: ReadonlyArray<string>;
}> = {
	claude: [
		'claude-sonnet-5',
		'claude-opus-4-8',
		'claude-haiku-4-5-20251001',
		'claude-sonnet-4-20250514',
		'claude-opus-4-20250514',
		'claude-3-5-sonnet-20241022',
		'claude-3-5-haiku-20241022',
		'claude-3-opus-20240229',
		'claude-3-sonnet-20240229',
		'claude-3-haiku-20240307',
	],
	openai: ['gpt-5.4', 'gpt-5.4-mini', 'gpt-5.4-nano'],
};

/**
 * Every model id the platform may call: the agent models plus the models
 * the background pipelines may be configured to run. May contain a dated
 * snapshot and its alias side by side (`claude-haiku-4-5-20251001` and
 * `claude-haiku-4-5`).
 */
export const SUPPORTED_LLM_MODEL_IDS: ReadonlyArray<string> = Array.from(
	new Set([
		...AGENT_LLM_MODELS.claude,
		...AGENT_LLM_MODELS.openai,
		...LLM_MODEL_PRICING.map((entry) => entry.modelId),
	]),
);
